<template>
  <b-badge
    v-if="displayText"
    :variant="statusVariant"
    class="text-capitalize"
  >
    {{ displayText }}
  </b-badge>
  <span v-else class="text-muted">-</span>
</template>

<script>
import { getPlanningStatusVariant, getPlanningStatusLabelKey } from '../usePlanningStatus'

export default {
  name: 'PlanningStatusBadge',
  props: {
    status: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    statusVariant() {
      return getPlanningStatusVariant(this.status)
    },
    displayText() {
      if (!this.status) return ''
      const key = getPlanningStatusLabelKey(this.status)
      if (!key) return ''
      const translated = this.$t(key)
      return translated !== key ? translated : (typeof this.status === 'object' ? (this.status && (this.status.name || this.status.code)) : this.status) || ''
    },
  },
}
</script>
